import axios from 'axios';
import store from '@/store';
// import { useAuthStore } from '@/store/authStore';

// Create an instance of Axios
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  //timeout: 10000, // Request timeout
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});
//new token 

// Optionally, add interceptors for request/response
apiClient.interceptors.request.use(
  /**
   * Interceptor function for Axios request configuration.
   * This function is used to modify the request configuration before it is sent.
   * It sets the 'Accept-Language' header based on the current language in the Vuex store,
   * and adds the authorization token to the request headers if it exists.
   *
   * @param {AxiosRequestConfig} config - The Axios request configuration object.
   * @returns {AxiosRequestConfig} - The modified request configuration.
   */
  async (config) => {
    // const authStore = useAuthStore();
    const language = store.getters.currentLanguage;
    // const token = authStore.getToken;
    
    // Set the 'Accept-Language' header to the current language
    config.headers['Accept-Language'] = language || 'ar';


    // if(token){
    //     config.headers['Authorization'] = `Bearer ${token}`;
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
